// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-wrapper[data-v-01cf62a7]{max-width:1440px;border:none;position:relative;min-width:320px;margin:0 auto;height:100%}@media (max-width:1279px){.content-wrapper[data-v-01cf62a7]{border:none}}", ""]);
// Exports
module.exports = exports;
